<template>
    <div class="field" :validation-error="validation" :class="{'is-invalid': validation != null}">
        <label :for="labelFor" class="label" v-if="label">
            <span v-html="label"></span>
            <span v-if="optional" class="is-size-7"> ({{ $t('global.optional') }})</span>
        </label>
        <slot/>
        <div class="notification is-danger has-text-weight-semibold validation-result is-light has-icon" v-if="validation">
            {{ validation }}
            <span class="icon"><i class="far fa-exclamation-triangle"></i></span>
        </div>
    </div>
</template>

<script>
export default {
    name: "ValidatedField",
    props: ["validation", "label", "labelFor", "optional"]
}
</script>